<template>
  <div>
    <div v-show="!challengeLoading">
      <v-btn
        v-if="!finished"
        class="customButton gray mr-1"
        @click="dialog = true"
        >도전 포기</v-btn
      >
      <v-btn v-if="!finished" class="customButton" @click="success"
        >도전 성공</v-btn
      >
      <v-btn v-if="finished" class="customButton" @click="create"
        >도전 새로 시작</v-btn
      >
    </div>
    <span v-if="alert" class="alert">
      <v-icon class="alertIcon">mdi-alert</v-icon>
      {{ alertMessage }}
    </span>

    <v-dialog v-model="dialog" persistent>
      <v-card>
        <v-card-title class="finish headline lighten-2 justify-center">
          Give Up
        </v-card-title>

        <v-card-text class="pt-5 text-center" style="word-break: keep-all">
          정말 포기하시겠어요?
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn class="customButton grey" @click="giveup()">예</v-btn>
          <v-btn class="customButton" @click="dialog = false">아니오</v-btn>
          <span v-if="alert2" class="alert">
            <v-icon class="alertIcon">mdi-alert</v-icon>
            {{ alertMessage2 }}
          </span>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "Finish",
  data() {
    return {
      succeed: undefined,
      alert: false,
      alertMessage: undefined,
      alert2: false,
      alertMessage2: undefined,
      dialog: false,
      challengeLoading: false
    };
  },
  computed: {
    challengeId() {
      return this.$store.getters.challengeId;
    },
    finished() {
      return this.$store.getters.finished;
    },
    isSucceed() {
      return this.$store.getters.succeed;
    },
  },
  methods: {
    success() {
      this.challengeLoading = true;
      // this.$axios
      //   .put("/challenges/" + this.challengeId, { succeed: true })
      //   .then((response) => {
      //     if (response.data === false) {
      //       this.alert = true;
      //       this.alertMessage = "매일 작성한 일기가 모두 통과해야 성공입니다.";
      //       this.challengeLoading = false;
      //       return false;
      //     } else {
      //       window.localStorage.setItem("challengeInfo", response.data);
      //       this.$router.push("/home");
      //       this.challengeLoading = false;
      //     }
      //   });
      this.$router.push("/home");
      this.challengeLoading = false;
    },
    giveup() {
      this.challengeLoading = true;
      // this.$axios
      //   .put("/challenges/" + this.challengeId, { succeed: false })
      //   .then((response) => {
      //     if (response.data === false) {
      //       this.alert2 = true;
      //       this.alertMessage2 = "일기를 모두 작성해주세요.";
      //       this.challengeLoading = false;
      //       return false;
      //     } else {
      //       window.localStorage.setItem(
      //         "challengeInfo",
      //         JSON.stringify(response.data)
      //       );
      //       this.$router.push("/home");
      //       this.challengeLoading = false;
      //     }
      //   });
      this.$router.push("/home");
      this.challengeLoading = false;
    },
    create() {
      this.challengeLoading = true;
      window.localStorage.setItem("new", 1);
      this.$router.push("/start");
      this.challengeLoading = false;
    },
  },
};
</script>